import { useEditorStore } from '../store/editor-store';
import { IconGallery, IconUpload } from './Icons';

export function LeftToolbar() {
  const tool = useEditorStore((s) => s.tool);
  const panel = useEditorStore((s) => s.panel);
  const past = useEditorStore((s) => s.past);
  const future = useEditorStore((s) => s.future);
  const setTool = useEditorStore((s) => s.setTool);
  const undo = useEditorStore((s) => s.undo);
  const redo = useEditorStore((s) => s.redo);
  const setPanel = useEditorStore((s) => s.setPanel);

  return (
    <aside className="ox-toolbar">
      <button
        type="button"
        className={tool === 'text' || panel === 'addText' || panel === 'text' ? 'active' : ''}
        onClick={() => {
          setTool('text');
          setPanel('addText');
        }}
      >
        <span className="ox-ico">T</span>
        Texto
      </button>
      <button
        type="button"
        className={tool === 'upload' || panel === 'image' ? 'active' : ''}
        onClick={() => {
          setTool('upload');
          setPanel('image');
        }}
      >
        <span className="ox-ico ox-ico-svg">
          <IconUpload />
        </span>
        Cargar
      </button>
      <button
        type="button"
        className={panel === 'gallery' ? 'active' : ''}
        onClick={() => {
          setTool('select');
          setPanel('gallery');
        }}
      >
        <span className="ox-ico ox-ico-svg">
          <IconGallery />
        </span>
        Galería
      </button>
      <button
        type="button"
        className={tool === 'products' || panel === 'products' ? 'active' : ''}
        onClick={() => {
          setTool('products');
          setPanel('products');
        }}
      >
        <span className="ox-ico">👕</span>
        Productos
      </button>
      <div className="ox-toolbar-spacer" />
      <button type="button" disabled={!past.length} onClick={undo}>
        <span className="ox-ico">↶</span>
        Deshacer
      </button>
      <button type="button" disabled={!future.length} onClick={redo}>
        <span className="ox-ico">↷</span>
        Rehacer
      </button>
    </aside>
  );
}
